module.exports = __webpack_public_path__ + "img/address-icon.301207a6.svg";